import { useEffect } from "react";
import { useLocation } from "wouter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function LoginSuccess() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    // 2초 후 홈으로 리다이렉트
    const timer = setTimeout(() => {
      setLocation('/');
    }, 2000);

    return () => clearTimeout(timer);
  }, [setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-green-600">
            <CheckCircle className="h-5 w-5" />
            로그인 성공
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-4">
            로그인이 완료되었습니다. 잠시 후 홈으로 이동합니다.
          </p>
          <Button
            onClick={() => setLocation('/')}
            className="w-full"
          >
            홈으로 이동
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

